import { Button } from "@/design-system/components/Button/Button";
import { colors } from "@material-ui/core";
import React from "react";
import { GoogleOAuthConfigModal } from "../../modals/GoogleOAuthConfigModal";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { GoogleAdsIcon } from "../../../components/icons/themes/logos";

const CustomerIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings } = existingConfig;

  return (
    <ConfigureDestinationsModal
      limitSettings={["customerId"]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const CustomerIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "customerId" in settings;

  return (
    <DestinationConfigRow
      name="Configuration"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  // only show the oauth flow if we're in server side mode
  var enable_row = existingConfig.connection_mode !== "server" ? true : false;

  // this comes from the google app verification process. They want links that
  // say Google Ads, to also have the icon. But also not show the icon alone
  // afaict. So we show <icon> Connect with Google if oauth is not configured.
  var icon = (
    <GoogleAdsIcon
      className="position mr-2 fill-white"
      height="2em"
      style={{ top: -2 }}
    />
  );

  const loginButton = (
    <Button
      variant="outline"
      onClick={setConfigModalOpen}
      className="text-grey font-semi-bold inline-block w-auto cursor-pointer rounded px-2 py-1"
    >
      {!oauthConfigured && icon}
      {oauthConfigured ? "Reconnect" : "Connect With Google Ads"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access Permission"
      disabled={enable_row}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const CONFIGURATION = "CONFIGURATION";
const OAUTH = "OAUTH";

const Rows = {
  [CONFIGURATION]: CustomerIDRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [CONFIGURATION]: CustomerIDModal,
  [OAUTH]: GoogleOAuthConfigModal,
};

const RowOrder = [CONFIGURATION, OAUTH];

export default {
  Rows,
  RowOrder,
  Modals,
};
